import { render, staticRenderFns } from "./UserRegistrations.vue?vue&type=template&id=489ee62f&scoped=true"
import script from "./UserRegistrations.vue?vue&type=script&lang=js"
export * from "./UserRegistrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ee62f",
  null
  
)

export default component.exports